import {Mutations} from "vuex-smart-module";

import WarehouseShopState, {
    WarehouseShopStatus
} from "@/store/modules/warehouse-shop/warehouse-shop-state";

import WarehouseShopData from "@/http/data/warehouse-shop-data";
import WarehouseShopOrderData from "@/http/data/warehouse-shop-order-data";

export default class WarehouseShopMutations
    extends Mutations<WarehouseShopState> {

    setShop(shop: WarehouseShopData|null): void {
        this.state.shop = shop;
    }

    setShopStatus(status: WarehouseShopStatus): void {
        this.state.shopStatus = status;
    }

    setOpenOrders(orders: WarehouseShopOrderData[]): void {
        this.state.openOrders = orders;
    }

    setOrdersStatus(status: WarehouseShopStatus): void {
        this.state.ordersStatus = status;
    }

    setSelectedBuilding(building: string|null): void {
        this.state.selectedBuilding = building;
    }

    setCurrentOrder(order: WarehouseShopOrderData|null): void {
        if (!this.state.shop) return;

        this.state.shop.current_order = order;
    }

    setIsSaving(value: boolean): void {
        this.state.isSaving = value;
    }

    setIsInitialized(value: boolean): void {
        this.state.isInitialized = value;
    }

    clear(): void {
        for (const url of Object.values(this.state.productThumbnailUrls)) {
            URL.revokeObjectURL(url);
        }

        this.state.shop = null;
        this.state.openOrders = [];
        this.state.productThumbnailUrls = {};
        this.state.shopStatus = WarehouseShopStatus.Failed;
        this.state.ordersStatus = WarehouseShopStatus.Failed;
        this.state.selectedBuilding = null;
        this.state.isSaving = false;
    }
}